"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  VirtualBox: ['virtual-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,20.5A2.5,2.5,0,0,0,18.5,18H16.583a.249.249,0,0,1-.241-.184,4.5,4.5,0,0,0-8.713.113A.093.093,0,0,1,7.538,18H7.5A2.5,2.5,0,0,0,5,20.5v2A1.5,1.5,0,0,0,6.5,24h13A1.5,1.5,0,0,0,21,22.5Zm-9-4A2.5,2.5,0,1,1,9.5,19,2.5,2.5,0,0,1,12,16.5Z', 'M17.015,8.48V4.395a.25.25,0,0,0-.38-.213L12.87,6.476a.248.248,0,0,0-.12.213v4.779a.25.25,0,0,0,.38.214l3.162-1.92h0A1.509,1.509,0,0,0,17.015,8.48Z', 'M11.871,5.169a.25.25,0,0,0,.26,0l3.838-2.34a.25.25,0,0,0,.011-.419L12.852.263h0a1.511,1.511,0,0,0-1.7,0l-3.11,2.15a.25.25,0,0,0,.012.419Z', 'M11.25,6.689a.25.25,0,0,0-.12-.214L7.4,4.192a.249.249,0,0,0-.38.213V8.481a1.511,1.511,0,0,0,.717,1.28l3.138,1.917a.249.249,0,0,0,.38-.213Z', 'M16.793,13.792a1,1,0,0,0,1.414,1.414l1.061-1.06a1,1,0,0,0-1.414-1.415Z', 'M22.707,9.292a1,1,0,0,0-1.414,0l-1.061,1.061a1,1,0,0,0,1.414,1.414l1.061-1.061A1,1,0,0,0,22.707,9.292Z', 'M7.207,15.206a1,1,0,0,0,0-1.414L6.146,12.731a1,1,0,0,0-1.414,1.415l1.061,1.06A1,1,0,0,0,7.207,15.206Z', 'M2.707,9.292a1,1,0,1,0-1.414,1.414l1.061,1.061a1,1,0,0,0,1.414-1.414Z']],
  AnkleTracker: ['ankle-tracker', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.674,10.1A1.458,1.458,0,0,0,9.13,11.555h5.74A1.458,1.458,0,0,0,16.326,10.1V5.315A1.454,1.454,0,0,0,15.12,3.884a.25.25,0,0,1-.207-.247V1.489a1,1,0,0,0-2,0V3.608a.25.25,0,0,1-.25.25H11.337a.25.25,0,0,1-.25-.25V1.489a1,1,0,0,0-2,0V3.637a.25.25,0,0,1-.207.247A1.454,1.454,0,0,0,7.674,5.315Zm2.978-.6H9.9a.25.25,0,0,1-.25-.25V6.167a.25.25,0,0,1,.25-.25h.75a1.79,1.79,0,0,1,0,3.579Z', 'M21.536,19.677c-.641-.827-.031-.354-3.416-3.01-.892-.7-2.068-1.623-3.626-2.853a.249.249,0,0,1-.1-.193l0-.183a.5.5,0,0,0-.5-.493H10.087a.5.5,0,0,0-.5.507l0,.17a.248.248,0,0,1-.1.2c-1.556,1.229-2.73,2.149-3.62,2.849C2.51,19.311,3.1,18.849,2.456,19.684c-1.322,1.771.231,3.095.816,3.594a.976.976,0,0,0,1.608-.746v-.894a1.274,1.274,0,0,1,.577-.971l4.416-2.389a.251.251,0,0,1,.366.177c.193,1.105.488,2.455.815,3.71a.976.976,0,0,0,1.889,0c.321-1.233.621-2.6.815-3.712a.251.251,0,0,1,.366-.177l4.417,2.389a1.276,1.276,0,0,1,.576.971v.894a.977.977,0,0,0,1.609.746c.639-.546,2.138-1.822.816-3.594Z', 'M18.258,8.2a1,1,0,0,0,0,2,2.435,2.435,0,1,0,0-4.87,1,1,0,0,0,0,2,.435.435,0,0,1,0,.87Z', 'M19.652,2.88a1,1,0,0,0,0,2A2.623,2.623,0,0,1,22,7.706a2.623,2.623,0,0,1-2.348,2.826,1,1,0,0,0,0,2A4.611,4.611,0,0,0,24,7.706,4.611,4.611,0,0,0,19.652,2.88Z', 'M3.307,7.768A2.437,2.437,0,0,0,5.742,10.2a1,1,0,1,0,0-2,.435.435,0,0,1,0-.87,1,1,0,0,0,0-2A2.438,2.438,0,0,0,3.307,7.768Z', 'M5.348,11.532a1,1,0,0,0-1-1A2.623,2.623,0,0,1,2,7.706,2.623,2.623,0,0,1,4.348,4.88a1,1,0,0,0,0-2A4.611,4.611,0,0,0,0,7.706a4.611,4.611,0,0,0,4.348,4.826A1,1,0,0,0,5.348,11.532Z']],
  ArtificialArm: ['artificial-arm', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.322,14.651a.247.247,0,0,0-.185-.073.244.244,0,0,0-.18.086l-2.3,2.649a1.709,1.709,0,0,1-1.228.588,1.666,1.666,0,0,1-1.268-.5.709.709,0,0,0-1,0L4.111,20.455a1.262,1.262,0,0,0-.372.9v1.672a.25.25,0,0,0,.25.25h4.75a.5.5,0,0,0,.382-.177l5.5-6.5a.5.5,0,0,0-.028-.677Z', 'M2.739,21.353A2.259,2.259,0,0,1,3.4,19.748L6.457,16.7a1.71,1.71,0,0,1,2.414,0A.765.765,0,0,0,9.4,16.9a.708.708,0,0,0,.508-.243l2.367-2.731a.251.251,0,0,0-.012-.341L9.593,10.921a.5.5,0,0,0-.685-.021L.416,18.412a.5.5,0,0,0-.169.375v3.988a.5.5,0,0,0,.5.5H2.489a.25.25,0,0,0,.25-.25Zm6.781-7.3a.75.75,0,1,1,0-1.06A.748.748,0,0,1,9.52,14.055Z', 'M23.753,7.587a1.243,1.243,0,0,0-.364-.884l-3.91-3.91a1.252,1.252,0,0,0-1.768,0L15.59,4.915a.75.75,0,0,1-1.061-1.061l.536-.568a1.5,1.5,0,0,0-2.122-2.122L11.871,2.237a6,6,0,0,0,.026,8.511c.631.623,1.935,1.836,3.22,3.122a2.007,2.007,0,0,0,2.834.005l5.438-5.4A1.245,1.245,0,0,0,23.753,7.587Z']],
  VideoProjector1: ['video-projector-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z', 'M22,0H2A1,1,0,0,0,2,2H22a1,1,0,0,0,0-2Z', 'M10.243,9.937l5.4-3a.5.5,0,0,0,0-.874l-5.4-3A.5.5,0,0,0,9.5,3.5v6a.5.5,0,0,0,.743.437Z', 'M16.5,17H14.24a.249.249,0,0,0-.249.231,3,3,0,0,1-5.982,0A.251.251,0,0,0,7.76,17H7.5A2.5,2.5,0,0,0,5,19.5v1.25a1.494,1.494,0,0,0,.75,1.291V23.25a.75.75,0,0,0,1.5,0V22.5a.25.25,0,0,1,.25-.25h9a.25.25,0,0,1,.25.25v.75a.75.75,0,0,0,1.5,0V22.041A1.494,1.494,0,0,0,19,20.75V19.5A2.5,2.5,0,0,0,16.5,17Z', 'M11,19a2,2,0,1,0-2-2A2,2,0,0,0,11,19Zm-.75-2a.75.75,0,1,1,.75.75A.75.75,0,0,1,10.25,17Z', 'M6,8.5a1,1,0,0,0-1-1H4a1,1,0,0,0,0,2H5A1,1,0,0,0,6,8.5Z', 'M4,5.5a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z', 'M20,7.5H19a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M21,3.5H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z']],
  BendablePhone: ['bendable-phone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.5,2H12.307a.5.5,0,0,0-.382.823,8.554,8.554,0,0,1,2.014,5.546L14,9.5v11A1.5,1.5,0,0,0,15.5,22h7A1.5,1.5,0,0,0,24,20.5V9.5A7.508,7.508,0,0,0,16.5,2ZM20,18.5a1,1,0,1,1-1-1A1,1,0,0,1,20,18.5ZM21,8.251V14.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V8.285a9.1,9.1,0,0,0-.552-3.126.5.5,0,0,1,.588-.657C18.885,4.951,20.992,5.63,21,8.251Z', 'M6.73,2.055a.506.506,0,0,0-.129,0A7.511,7.511,0,0,0,0,9.5,1.5,1.5,0,0,0,1.5,11h7A1.5,1.5,0,0,0,10,9.5a6.515,6.515,0,0,1,.78-3.091,6.712,6.712,0,0,1,.375-.609.5.5,0,0,0,.031-.517A6.022,6.022,0,0,0,6.73,2.055Z']],
  BodyScanner: ['body-scanner', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,22H14.005a.249.249,0,0,1-.249-.275l.445-4.45a.253.253,0,0,0-.063-.193A.251.251,0,0,0,13.953,17H10.047a.251.251,0,0,0-.185.082.253.253,0,0,0-.063.193l.445,4.45A.249.249,0,0,1,9.995,22H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z', 'M12,9.31A3.227,3.227,0,1,0,8.772,6.083,3.231,3.231,0,0,0,12,9.31Z', 'M15.765,13a.249.249,0,0,0,.243-.309,4.119,4.119,0,0,0-8.016,0A.25.25,0,0,0,8.235,13Z', 'M5,15a2.5,2.5,0,0,0-1.364-2.224.249.249,0,0,1-.136-.222V1a1,1,0,0,0-2,0V12.554a.249.249,0,0,1-.136.222,2.494,2.494,0,0,0,0,4.447.252.252,0,0,1,.136.223V23a1,1,0,0,0,2,0V17.446a.252.252,0,0,1,.136-.223A2.5,2.5,0,0,0,5,15Z', 'M24,15a2.5,2.5,0,0,0-1.364-2.224.249.249,0,0,1-.136-.222V1a1,1,0,0,0-2,0V12.554a.249.249,0,0,1-.136.222,2.494,2.494,0,0,0,0,4.447.252.252,0,0,1,.136.223V23a1,1,0,0,0,2,0V17.446a.252.252,0,0,1,.136-.223A2.5,2.5,0,0,0,24,15Z', 'M6.500 15.000 A1.000 1.000 0 1 0 8.500 15.000 A1.000 1.000 0 1 0 6.500 15.000 Z', 'M9.500 15.000 A1.000 1.000 0 1 0 11.500 15.000 A1.000 1.000 0 1 0 9.500 15.000 Z', 'M12.500 15.000 A1.000 1.000 0 1 0 14.500 15.000 A1.000 1.000 0 1 0 12.500 15.000 Z', 'M15.500 15.000 A1.000 1.000 0 1 0 17.500 15.000 A1.000 1.000 0 1 0 15.500 15.000 Z']],
  VideoProjector: ['video-projector', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.343,9.937l7.2-4a.5.5,0,0,0,0-.874l-7.2-4A.5.5,0,0,0,8.6,1.5v8a.5.5,0,0,0,.246.431A.566.566,0,0,0,9.343,9.937Z', 'M5.5,10.5a1,1,0,0,0-1-1h-1a1,1,0,0,0,0,2h1A1,1,0,0,0,5.5,10.5Z', 'M4,6A1,1,0,0,0,3,5H2A1,1,0,0,0,2,7H3A1,1,0,0,0,4,6Z', 'M2,2A1,1,0,0,0,2,0H1A1,1,0,0,0,1,2Z', 'M20.5,9.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M7,15a1,1,0,0,0-1-1H5a1,1,0,0,0,0,2H6A1,1,0,0,0,7,15Z', 'M19,14H18a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M22,5H21a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M23,0H22a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M17.5,17H15.24a.249.249,0,0,0-.249.231,3,3,0,0,1-5.982,0A.251.251,0,0,0,8.76,17H8.5A2.5,2.5,0,0,0,6,19.5v1a1.491,1.491,0,0,0,.5,1.11V23a1,1,0,0,0,2,0v-.75A.25.25,0,0,1,8.75,22h8.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V21.61A1.491,1.491,0,0,0,20,20.5v-1A2.5,2.5,0,0,0,17.5,17Z', 'M12,19a2,2,0,1,0-2-2A2,2,0,0,0,12,19Zm-.75-2a.75.75,0,1,1,.75.75A.75.75,0,0,1,11.25,17Z']],
  VirtualHome: ['virtual-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.132,10.342A1.659,1.659,0,0,0,6.789,12H17.211a1.659,1.659,0,0,0,1.657-1.658V4.553a.5.5,0,0,0-.231-.422L12.269.078a.5.5,0,0,0-.538,0L5.363,4.131a.5.5,0,0,0-.231.422Zm5.379-6.223,4.052,2.315a.5.5,0,0,1,0,.869L10.511,9.618a.5.5,0,0,1-.748-.434V4.553A.5.5,0,0,1,10.511,4.119Z', 'M17.5,16.5H15.583a.249.249,0,0,1-.241-.184,4.5,4.5,0,0,0-8.707.089.125.125,0,0,1-.121.095H6.5A2.5,2.5,0,0,0,4,19v2a1.5,1.5,0,0,0,.857,1.355A.25.25,0,0,1,5,22.581V23a1,1,0,0,0,2,0v-.25a.25.25,0,0,1,.25-.25h9.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0v-.419a.25.25,0,0,1,.143-.226A1.5,1.5,0,0,0,20,21V19A2.5,2.5,0,0,0,17.5,16.5ZM11,15a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,11,15Z']],
  VirtualTapFinger: ['virtual-tap-finger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,20.5A2.5,2.5,0,0,0,18.5,18H16.583a.251.251,0,0,1-.241-.184,4.5,4.5,0,0,0-8.707.089A.125.125,0,0,1,7.514,18H7.5A2.5,2.5,0,0,0,5,20.5v2A1.5,1.5,0,0,0,6.5,24h13A1.5,1.5,0,0,0,21,22.5Zm-9-4A2.5,2.5,0,1,1,9.5,19,2.5,2.5,0,0,1,12,16.5Z', 'M11.166,4.5a1,1,0,0,0-1,1v4.13a.25.25,0,0,1-.41.192l-.449-.376a.833.833,0,0,0-1.282,1.065l1.578,1.9A.249.249,0,0,0,9.8,12.5H15.25a.25.25,0,0,0,.25-.25V10.723A2.222,2.222,0,0,0,13.278,8.5h-.861a.249.249,0,0,1-.25-.25V5.5A1,1,0,0,0,11.166,4.5Z', 'M4,7.5a1,1,0,0,0,1-1v-4A.5.5,0,0,1,5.5,2h13a.5.5,0,0,1,.5.5v4a1,1,0,0,0,2,0V2a2,2,0,0,0-2-2H5A2,2,0,0,0,3,2V6.5A1,1,0,0,0,4,7.5Z', 'M17.854,12.734,16.793,13.8a1,1,0,1,0,1.414,1.414l1.061-1.061a1,1,0,1,0-1.414-1.414Z', 'M22.707,9.3a1,1,0,0,0-1.414,0l-1.061,1.06a1,1,0,1,0,1.414,1.414l1.061-1.06A1,1,0,0,0,22.707,9.3Z', 'M6.5,15.5A1,1,0,0,0,7.207,13.8L6.146,12.734a1,1,0,1,0-1.414,1.414l1.061,1.061A1,1,0,0,0,6.5,15.5Z', 'M2.707,9.3a1,1,0,1,0-1.414,1.414l1.061,1.06a1,1,0,1,0,1.414-1.414Z']],
  VirtualTouchBoard: ['virtual-touch-board', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.666,4.5a1,1,0,0,0-1,1v4.13a.25.25,0,0,1-.41.192l-.449-.376a.833.833,0,0,0-1.282,1.065l1.578,1.9a.249.249,0,0,0,.193.091H18.75a.25.25,0,0,0,.25-.25V10.723A2.222,2.222,0,0,0,16.778,8.5h-.861a.249.249,0,0,1-.25-.25V5.5A1,1,0,0,0,14.666,4.5Z', 'M21,2a2,2,0,0,0-2-2H5A2,2,0,0,0,3,2V6.5a1,1,0,0,0,2,0v-4A.5.5,0,0,1,5.5,2h13a.5.5,0,0,1,.5.5v4a1,1,0,0,0,2,0Z', 'M17.5,16.5H15.583a.251.251,0,0,1-.241-.184,4.5,4.5,0,0,0-8.707.089.125.125,0,0,1-.121.095H6.5A2.5,2.5,0,0,0,4,19v2a1.5,1.5,0,0,0,.857,1.355A.249.249,0,0,1,5,22.582V23a1,1,0,0,0,2,0v-.25a.25.25,0,0,1,.25-.25h9.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0v-.42a.249.249,0,0,1,.143-.225A1.5,1.5,0,0,0,20,21V19A2.5,2.5,0,0,0,17.5,16.5ZM11,15a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,11,15Z']],
  BendablePhoneTouch: ['bendable-phone-touch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,9.75H5.578A7.513,7.513,0,0,0,0,17a1.5,1.5,0,0,0,1.5,1.5h7A1.5,1.5,0,0,0,10,17a6.481,6.481,0,0,1,1.335-3.947.251.251,0,0,0,.015-.281A6.252,6.252,0,0,0,6,9.75Z', 'M.266,4.97A3.749,3.749,0,0,0,5.193,6.933L7.835,5.8a.249.249,0,0,1,.3.076A3.767,3.767,0,0,0,11.1,7.326a3.73,3.73,0,0,0,1.477-.3l3.9-1.68a.251.251,0,0,1,.329.13.749.749,0,1,0,1.376-.592L16.388.7a.749.749,0,1,0-1.377.592L16.02,3.634a.251.251,0,0,1-.13.329l-3.905,1.68a2.249,2.249,0,0,1-2.232-.264.25.25,0,0,1,.051-.43l1.59-.684A.75.75,0,0,0,10.8,2.887L4.6,5.555a2.256,2.256,0,0,1-2.236-.262.249.249,0,0,1,.05-.43l7.956-3.424A.75.75,0,1,0,9.777.061L.658,3.985A.751.751,0,0,0,.266,4.97Z', 'M24,16a7.508,7.508,0,0,0-7.5-7.5H9.381a.25.25,0,0,0-.106.476,7.807,7.807,0,0,1,3.414,3.114A6.467,6.467,0,0,1,14,16v6.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5Zm-6.5,2.5A1.5,1.5,0,0,1,16,17V15.775a8.243,8.243,0,0,0-1.358-4.5.5.5,0,0,1-.016-.527.528.528,0,0,1,.465-.248l1.986.128A5.209,5.209,0,0,1,22,15.726V17a1.5,1.5,0,0,1-1.5,1.5ZM20,21a1,1,0,1,1-1-1A1,1,0,0,1,20,21Z']],
  VirtualBoxes: ['virtual-boxes', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.015,8.48V4.395a.25.25,0,0,0-.38-.213L12.87,6.476a.248.248,0,0,0-.12.213v4.779a.25.25,0,0,0,.38.214l3.162-1.92h0A1.509,1.509,0,0,0,17.015,8.48Z', 'M11.871,5.169a.25.25,0,0,0,.26,0l3.838-2.34a.25.25,0,0,0,.011-.419L12.852.263h0a1.511,1.511,0,0,0-1.7,0l-3.11,2.15a.25.25,0,0,0,.012.419Z', 'M11.25,6.689a.25.25,0,0,0-.12-.214L7.4,4.192a.249.249,0,0,0-.38.213V8.481a1.511,1.511,0,0,0,.717,1.28l3.138,1.917a.249.249,0,0,0,.38-.213Z', 'M17.5,16.5H15.581a.251.251,0,0,1-.24-.181,4.5,4.5,0,0,0-8.706.086.125.125,0,0,1-.121.095H6.5A2.5,2.5,0,0,0,4,19v2a1.5,1.5,0,0,0,.857,1.355A.25.25,0,0,1,5,22.58V23a1,1,0,0,0,2,0v-.25a.25.25,0,0,1,.25-.25h9.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V22.58a.25.25,0,0,1,.143-.226A1.5,1.5,0,0,0,20,21V19A2.5,2.5,0,0,0,17.5,16.5ZM11,15a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,11,15Z']],
  UserPolaroid: ['user-polaroid', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.500 6.112 A1.000 1.000 0 1 0 17.500 6.112 A1.000 1.000 0 1 0 15.500 6.112 Z', 'M16.500 11.500 A1.000 1.000 0 1 0 18.500 11.500 A1.000 1.000 0 1 0 16.500 11.500 Z', 'M6.177 12.000 A1.000 1.000 0 1 0 8.177 12.000 A1.000 1.000 0 1 0 6.177 12.000 Z', 'M5.500 6.500 A1.000 1.000 0 1 0 7.500 6.500 A1.000 1.000 0 1 0 5.500 6.500 Z', 'M9.250 8.250 A2.750 2.750 0 1 0 14.750 8.250 A2.750 2.750 0 1 0 9.250 8.250 Z', 'M21.875,21.047a.5.5,0,0,1-.375-.484V3.437a.5.5,0,0,1,.375-.484A1.5,1.5,0,0,0,21.5,0H2.5a1.5,1.5,0,0,0-.375,2.953.5.5,0,0,1,.375.484V20.563a.5.5,0,0,1-.375.484A1.5,1.5,0,0,0,2.5,24h19a1.5,1.5,0,0,0,.375-2.953ZM19.5,20.5a.5.5,0,0,1-.5.5H14.293a.5.5,0,0,1-.5-.524l.1-2.111a.5.5,0,0,1,.5-.477H15a.5.5,0,0,0,.5-.5V15.5a3.5,3.5,0,0,0-7,0v1.888a.5.5,0,0,0,.5.5h.607a.5.5,0,0,1,.5.477l.1,2.111a.5.5,0,0,1-.5.524H5a.5.5,0,0,1-.5-.5V3.5A.5.5,0,0,1,5,3H19a.5.5,0,0,1,.5.5Z']],
  Robot1: ['robot-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,7.431a2.022,2.022,0,0,0-.483.059.25.25,0,0,1-.3-.176,8,8,0,0,0-2.027-3.5.251.251,0,0,1,0-.35A2,2,0,1,0,14.519,1.07a1.968,1.968,0,0,0-.191.448.248.248,0,0,1-.3.173,8.016,8.016,0,0,0-4.05,0,.248.248,0,0,1-.3-.173,1.968,1.968,0,0,0-.191-.448A2,2,0,1,0,6.314,3.462a.251.251,0,0,1,0,.35,8,8,0,0,0-2.027,3.5.25.25,0,0,1-.3.176,2,2,0,1,0,0,3.882.25.25,0,0,1,.3.176,8,8,0,0,0,2.027,3.5.25.25,0,0,1,0,.35,1.948,1.948,0,0,0-.295.391,2,2,0,1,0,3.462,2,1.9,1.9,0,0,0,.19-.447.25.25,0,0,1,.306-.172c.108.029.216.056.327.081a.249.249,0,0,1,.2.244v1.79a1.72,1.72,0,0,0,.435,1.156.249.249,0,0,1,.065.168v1.069a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25V20.612a.247.247,0,0,1,.065-.168,1.72,1.72,0,0,0,.435-1.156V17.5a.249.249,0,0,1,.2-.244c.111-.025.219-.052.327-.081a.25.25,0,0,1,.306.172,1.9,1.9,0,0,0,.19.447,2,2,0,1,0,3.462-2,1.948,1.948,0,0,0-.3-.391.25.25,0,0,1,0-.35,8.008,8.008,0,0,0,2.027-3.5.25.25,0,0,1,.3-.176A2,2,0,1,0,20.5,7.431Zm-5,4a2,2,0,1,1,2-2A2,2,0,0,1,15.5,11.431Zm-7,0a2,2,0,1,1,2-2A2,2,0,0,1,8.5,11.431Z']],
  Webcam: ['webcam', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.75,8.5A2.75,2.75,0,1,0,12,11.25,2.752,2.752,0,0,0,14.75,8.5ZM11,8.5a1,1,0,1,1,1,1A1,1,0,0,1,11,8.5Z', 'M12,1.376A1.685,1.685,0,0,0,13.694.461.251.251,0,0,0,13.5.132a8.6,8.6,0,0,0-3,0,.251.251,0,0,0-.193.329A1.685,1.685,0,0,0,12,1.376Z', 'M13.65,17.235a.25.25,0,0,1,.125-.421A8.5,8.5,0,0,0,15.472.74a.251.251,0,0,0-.341.152A3.132,3.132,0,0,1,12,2.876,3.132,3.132,0,0,1,8.869.892.251.251,0,0,0,8.528.74a8.5,8.5,0,0,0,1.7,16.074.25.25,0,0,1,.125.421L5.293,22.293a1,1,0,0,0,1.414,1.414l3.866-3.866a.25.25,0,0,1,.427.177V23a1,1,0,0,0,2,0V20.018a.25.25,0,0,1,.427-.177l3.866,3.866a1,1,0,0,0,1.414-1.414ZM7.75,8.5A4.25,4.25,0,1,1,12,12.75,4.255,4.255,0,0,1,7.75,8.5Z']],
  VirtualHouse: ['virtual-house', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,20.5A2.5,2.5,0,0,0,18.5,18H16.583a.249.249,0,0,1-.241-.184,4.5,4.5,0,0,0-8.713.113A.093.093,0,0,1,7.538,18H7.5A2.5,2.5,0,0,0,5,20.5v2A1.5,1.5,0,0,0,6.5,24h13A1.5,1.5,0,0,0,21,22.5Zm-9-4A2.5,2.5,0,1,1,9.5,19,2.5,2.5,0,0,1,12,16.5Z', 'M16.793,13.793a1,1,0,0,0,1.414,1.414l1.061-1.061a1,1,0,0,0-1.414-1.414Z', 'M22.707,9.293a1,1,0,0,0-1.414,0l-1.061,1.06a1,1,0,0,0,1.414,1.414l1.061-1.06A1,1,0,0,0,22.707,9.293Z', 'M7.207,15.207a1,1,0,0,0,0-1.414L6.146,12.732a1,1,0,0,0-1.414,1.414l1.061,1.061A1,1,0,0,0,7.207,15.207Z', 'M2.707,9.293a1,1,0,0,0-1.414,1.414l1.061,1.06a1,1,0,0,0,1.414-1.414Z', 'M6,9a1.5,1.5,0,0,0,1.5,1.5h9A1.5,1.5,0,0,0,18,9V4a.5.5,0,0,0-.231-.422l-5.5-3.5a.5.5,0,0,0-.538,0l-5.5,3.5A.5.5,0,0,0,6,4Zm4.748-5.434,3.5,2a.5.5,0,0,1,0,.868l-3.5,2A.5.5,0,0,1,10,8V4A.5.5,0,0,1,10.748,3.566Z']]
};
exports["default"] = _default;